import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Collapse,
  Divider,
} from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useQuery } from "react-query";
import { fetchFotoBene } from "../../api/fotobene";
import FotoUploadComponent from "./FotoUploadComponent";
import FotoGalleryComponent from "./FotoGalleryComponent";

interface FotoBeneManagerProps {
  id_bene_contratto: number;
  autoOpenUpload?: boolean;
}

const FotoBeneManager: React.FC<FotoBeneManagerProps> = ({
  id_bene_contratto,
  autoOpenUpload = false,
}) => {
  const [showUpload, setShowUpload] = useState(autoOpenUpload);

  useEffect(() => {
    if (autoOpenUpload) {
      setShowUpload(true);
    }
  }, [autoOpenUpload]);

  const {
    data: fotoResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["fotobene", id_bene_contratto],
    queryFn: () => fetchFotoBene(id_bene_contratto),
    refetchOnMount: true,
    onSuccess: (data) => {
      console.log("Foto loaded:", data);
    },
  });

  const foto = fotoResponse?.data || [];
  
  console.log("FotoBeneManager - fotoResponse:", fotoResponse, "foto array:", foto, "isLoading:", isLoading);

  const handleUploadSuccess = () => {
    setShowUpload(false);
    refetch();
  };

  return (
    <Box>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          startIcon={<AddPhotoAlternateIcon />}
          onClick={() => setShowUpload(!showUpload)}
          size="small"
        >
          {showUpload ? "Chiudi" : "Aggiungi Foto"}
        </Button>
      </Box>

      <Collapse in={showUpload}>
        <Box sx={{ mb: 2 }}>
          <FotoUploadComponent
            id_bene_contratto={id_bene_contratto}
            onUploadSuccess={handleUploadSuccess}
            onClose={() => setShowUpload(false)}
          />
        </Box>
      </Collapse>

      <FotoGalleryComponent
        foto={foto}
        onUpdate={refetch}
        loading={isLoading}
      />
    </Box>
  );
};

export default FotoBeneManager;
